let { Sidechain } = require("@nprapps/sidechain");
let guest = Sidechain.registerGuest();


let $ = require("./lib/qsa");

// ---- 1. Grab the server-rendered cards (EJS already built them into #boe-col1) ----
const allCards = $('.boe-election2026__district-item');

// ---- 2. Column distribution (one-time per breakpoint, not per height change) ----
const container = $.one('#boe-election2026__district-container');
const columnEls = $(".boe-election2026__district-column");

const mediaQueries = {
  tablet: window.matchMedia('(min-width: 601px)'),
};

const breakpoints = [
  [mediaQueries.tablet, 2],
  [{matches: true}, 1]
]

function getColumnCount() {
  return breakpoints.find(([ q, c ]) => q.matches)[1];
}

function distributeIntoColumns(columnCount) {
  const activeElement = document.activeElement;

  for (let i = 0; i < columnEls.length; i++) {
    let col = columnEls[i];
    col.style.display = i < columnCount ? 'flex' : 'none';
  }

  allCards.forEach((card, index) => {
    columnEls[index % columnCount].appendChild(card);
  });

  activeElement.focus();
}

let currentColumnCount
if (container) {
  currentColumnCount = getColumnCount();
  distributeIntoColumns(currentColumnCount);
  guest.sendHeight();
}

function handleBreakpointChange() {
  const newColumnCount = getColumnCount();
  if (newColumnCount !== currentColumnCount) {
    currentColumnCount = newColumnCount;
    distributeIntoColumns(currentColumnCount);
    guest.sendHeight();
  }
}

mediaQueries.tablet.addEventListener('change', handleBreakpointChange);

// delegate the event listener
function setOpen(details, isOpen) {
  const wrapper = details.querySelector(".details-content-wrapper");
  if (isOpen) {
        wrapper.style.gridTemplateRows = '0fr';
    const onEnd = (event) => {
      if (event.propertyName !== 'grid-template-rows') return;
      details.open = false;
      wrapper.removeEventListener('transitionend', onEnd);
    };
    wrapper.addEventListener('transitionend', onEnd, { once: true });
    
  } else {

    details.open = true;
    requestAnimationFrame(() => wrapper.style.gridTemplateRows = "1fr");
  }
  guest.sendHeight();
}

function handleToggle(e) {
  let summary = e.target.closest("summary");
  if (!summary) return;
  let details = summary.closest("details");
  if (!details) return;
  if (!details) return;
  const isOpen = details.open;
  console.log("isopen", isOpen)
  e.preventDefault();
  setOpen(details, isOpen);
}

const detailsBtn = document.getElementById("boe-election2026__district-btn-toggle");
const detailsBtnSp = document.getElementById("boe-election2026__district-btn-toggle-sp");

function toggleBtnCopy(e, lang) {
  const allDetails = [...container.querySelectorAll("details")];
  const openCount = allDetails.filter(detail => detail.open).length;
  const mostlyOpen = openCount > allDetails.length / 2;
  allDetails.forEach(detail => setOpen(detail, mostlyOpen));
  e.currentTarget.setAttribute("aria-expanded", !mostlyOpen);
  const labels = {
    sp:  ["Contraer todo", "Expandir todo"],
    eng: ["Collapse all cards", "Expand all cards"]
  };
  e.currentTarget.textContent = labels[lang][mostlyOpen ? 1 : 0];
}

detailsBtnSp?.addEventListener("click", (e) => {
  toggleBtnCopy(e, "sp");
});

detailsBtn?.addEventListener("click", (e) => {
  toggleBtnCopy(e, "eng");
});

if (container) container.addEventListener("click", handleToggle);

